import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import CancerNavigationHeartIcon from "assets/images/CancerNavigationHeart.svg";
import DashboardCtaCard from ".";
import Translate from "translate/Translate";

const CancerNavigationDashboardCtaCard = () => {
  return (
    <DashboardCtaCard
      icon={CancerNavigationHeartIcon}
      header={<Translate text={"Cancer Navigation"} />}
      subheader={
        <Translate
          text={"We have a dedicated team to help support your journey."}
        />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "cancer_survey",
            ctaLocation: "dashboard_card",
            ctaId: "cancer_navigation"
          });
        },
        overrideClick: false,
        target: "blank",
        text: "View",
        url: PATHS.CANCER_GUARDIAN_RESOURCE
      }}
    />
  );
};

export default CancerNavigationDashboardCtaCard;
